import { render, staticRenderFns } from "./SfProductCard.vue?vue&type=template&id=7c05f3d9"
import script from "./SfProductCard.vue?vue&type=script&lang=js"
export * from "./SfProductCard.vue?vue&type=script&lang=js"
import style0 from "./SfProductCard.vue?vue&type=style&index=0&id=7c05f3d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports